export default __webpack_public_path__ + "static/media/TotalAssets.ac5e8cc7.svg";